"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CopyOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var CopyOutlineSVG = function CopyOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M26.9 24H13.1a2.1 2.1 0 01-2.1-2.1V4.1A2.1 2.1 0 0113.1 2h13.8A2.1 2.1 0 0129 4.1v17.8a2.1 2.1 0 01-2.1 2.1zm0-19.9H13.1v17.8h13.8zM7 27.94l3 .01V30H7.06A2.06 2.06 0 015 27.94V25h2.01zM16 27.98V30h-4v-2.04l4 .02zM20.94 28l.06-2h2v1.94A2.06 2.06 0 0120.94 30H18v-2.01zM5 12.06A2.06 2.06 0 017.06 10H9v2H7.06l-.01 3H5zM7.04 17l-.02 6H5v-6h2.04z"
  }));
};
exports.CopyOutlineSVG = CopyOutlineSVG;
CopyOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CopyOutlineSVG);
exports.default = _default;